import { render, staticRenderFns } from "./FormLangSwitcher.vue?vue&type=template&id=26ab9b07"
import script from "./FormLangSwitcher.vue?vue&type=script&lang=js"
export * from "./FormLangSwitcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports